import { z } from 'zod';
import { userSchema } from './users';

export const loginRequestSchema = z.object({
  username: z.string().min(1, 'Enter your username or email.'),
  password: z.string().min(1, 'Enter your password.'),
});

export const registerRequestSchema = z.object({
  name: z.string().min(1, 'Enter your full name.'),
  email: z.string().email('Enter a valid email address.'),
  password: z.string().min(8, 'Password must be at least 8 characters.'),
});

export const authSessionSchema = z.object({
  success: z.boolean().optional(),
  nonce: z.string().optional(),
  user: userSchema,
});

export const authMessageSchema = z.object({
  success: z.boolean().default(true),
  message: z.string(),
});

export type LoginRequest = z.infer<typeof loginRequestSchema>;
export type RegisterRequest = z.infer<typeof registerRequestSchema>;
export type AuthSession = z.infer<typeof authSessionSchema>;
export type AuthMessage = z.infer<typeof authMessageSchema>;
